import { useId } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  size?: Unit;
  className?: string;
  colors?: [string, string];
};

export const WinnerGroup = ({
  size = 2,
  className,
  colors = ['#9A45FF', '#03FFBD'],
}: Props) => {
  const id = useId();
  const gradientId = `winnerGroup-gradient-${id}`;
  const clipId = `winnerGroup-clip-${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 16"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M8.5293 6.21582C10.2193 6.21585 11.5896 7.5861 11.5898 9.27637C11.5898 10.4324 10.9491 11.4394 10.0029 11.96C11.1065 12.3808 11.9707 13.2604 12.3447 14.3555C12.764 13.711 13.5067 13.2822 14.3525 13.2822C15.6612 13.2823 16.7227 14.3081 16.7227 15.5732H0C0 14.3081 1.0614 13.2823 2.37012 13.2822C3.39169 13.2822 4.26283 13.9074 4.5957 14.7832C4.87194 13.4914 5.81267 12.4342 7.05664 11.96C6.11048 11.4394 5.46878 10.4327 5.46875 9.27637C5.46897 7.58644 6.83936 6.21598 8.5293 6.21582ZM2.60645 9.43164C3.57159 9.43183 4.35444 10.2145 4.35449 11.1797C4.35445 12.1449 3.5716 12.9275 2.60645 12.9277C1.64113 12.9277 0.858441 12.145 0.858398 11.1797C0.858455 10.2144 1.64114 9.43164 2.60645 9.43164ZM14.5889 9.43164C15.5539 9.43191 16.3359 10.2146 16.3359 11.1797C16.3359 12.1448 15.554 12.9275 14.5889 12.9277C13.6236 12.9277 12.8409 12.145 12.8408 11.1797C12.8409 10.2144 13.6236 9.43164 14.5889 9.43164ZM3.92285 5.68066H2.47852V7.08691H1.39062V4.59277H3.92285V5.68066ZM15.3389 7.08691H14.251V5.68066H12.8076V4.59277H15.3389V7.08691ZM10.2559 2.43262L12.5469 1.5752L11.0215 5.34277H6.03711L4.51172 1.5752L6.71484 2.43262L8.5293 -0.000976562L10.2559 2.43262Z"
          fill={`url(#${gradientId})`}
        />
      </g>
      <defs>
        <linearGradient
          id={gradientId}
          x1="8.36133"
          y1="-0.000976098"
          x2="8.36133"
          y2="15.5732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
        <clipPath id={clipId}>
          <rect width="16.7223" height="15.5739" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
